import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatableserver";
// import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
  name: "CreateDiagPage",
  data() {
    let ss = new MainService();
    return {
      msg: "CreateDiagPage",
      ss: ss,
      ajax: {
        url: ss.indexCreateDiag(),
        headers: ss.getToken(),
      },
      columns: [
        {
          data: "id",
          name: "id",
          orderable: false,
          searchable: false,
          visible: false,
        },
        {
          data: "DT_RowIndex",
          name: "DT_RowIndex",
          title: "N°",
          orderable: false,
          searchable: false,
        },
        { data: "paterno", name: "paterno", title: "Paterno" },
        { data: "materno", name: "materno", title: "Materno" },
        { data: "nombre", name: "nombre", title: "Nombre" },
        { data: "ci", name: "ci", title: "CI" },

        {
          data: "action",
          orderable: false,
          title: "Acciones",
          searchable: false,
        },
      ],
      creatediags: [],
      creatediag: {
        nota_d: "", // Inicializar nota_d aquí
        pdf: "",
        no_factura: "",
        evaluador: "",
        nota_o: "", // Inicializar pdf aquí
        Idioma: "",
        Carera: "",
      },
      isLoading: false,
      errorBag: {},
      gestion: null,
      notaTotal: 0,
      carreras: "",
      unidadAcademica: "",
      evaluadores: "",
      idiomas: "",
      filterci: "",
    };
  },
  methods: {
    filterCreateDiag() {
      this.errorBag = {};
      this.$refs["view-filter"].show();
    },
    filter() {
      this.isLoading = true;
      this.ss
        .filtradoCreateDiag(this.filterci)
        .then((result) => {
          let response = result.data;
          this.creatediag = response.data;
          this.gestion = response.gestion;
          this.instituciones = response.instituciones;
          this.idiomas = response.idiomas;
          this.evaluadores = response.evaluadores;
          this.carreras = response.carreras;
          this.unidadAcademica = response.unidadAcademica;
          this.$refs["view-creatediag"].show();
          this.$refs["view-filter"].hide();
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
        });
    },
    calcularNotaTotal() {
      const nota_d = parseFloat(this.creatediag.nota_d);
      const nota_o = parseFloat(this.creatediag.nota_o);

      // Verifica que las notas sean válidas
      if (!isNaN(nota_d) && !isNaN(nota_o)) {
        this.notaTotal = nota_o * 0.25 + nota_d * 0.75;
      } else {
        this.notaTotal = 0;
      }
    },
    showCreateDiag(id) {
      this.isLoading = true;
      this.ss
        .showCreateDiag(id)
        .then((result) => {
          let response = result.data;
          this.creatediag = response.data;
          this.gestion = response.gestion;
          this.instituciones = response.instituciones;
          this.idiomas = response.idiomas;
          this.evaluadores = response.evaluadores;
          this.carreras = response.carreras;
          this.unidadAcademica = response.unidadAcademica;
          this.$refs["view-creatediag"].show();
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
        });
    },
    editCreateDiag() {
      this.$refs["frm-creatediag"].show();
      this.$refs["view-creatediag"].hide();
    },
    cancelCreateDiag() {
      if (this.creatediag.id) {
        this.$refs["view-creatediag"].show();
      }
      this.$refs["frm-creatediag"].hide();
    },
    saveCreateDiag() {
      // Obtener el archivo seleccionado
      let file = document.querySelector('input[type="file"]').files[0];

      // Crear un FormData para enviar el archivo al backend
      let formData = new FormData();
      formData.append("File", file);

      // Enviar el archivo al backend utilizando la función uploadFile
      this.ss
        .uploadFile(formData)
        .then((response) => {
          this.creatediag.pdf = response.data.data;
          // Guardar la instancia
          this.ss
            .storeCreateDiag(this.creatediag)
            .then((result) => {
              let response = result.data;
              this.$bvToast.toast(response.msg, {
                title: "Correcto",
                variant: "success",
                autoHideDelay: 5000,
              });
              this.$refs["frm-creatediag"].hide();
              this.$refs["datatable-creatediag"].reload();
            })
            .catch((error) => {
              this.errorBag = error.response.data.errors;
              this.$bvToast.toast(
                "Problema al Guardar el Registro, favor verificar los Datos",
                {
                  title: "Error",
                  variant: "danger",
                  autoHideDelay: 5000,
                }
              );
            });
        })
        .catch((error) => {
          // Aquí puedes manejar los errores, por ejemplo, mostrar un mensaje de error al usuario
        });
    },

    deleteCreateDiag() {
      this.$swal({
        title: "¿Estás seguro que deseas eliminar?",
        text: "Esta acción es irreversible!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sí, eliminar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          this.ss
            .destroyCreateDiag(this.creatediag)
            .then((result) => {
              let response = result.data;
              this.$swal({
                title: "¡Eliminado!",
                text: "El archivo ha sido eliminado.",
                icon: "success",
              });
              this.$refs["view-creatediag"].hide();
              this.$refs["datatable-creatediag"].reload();
            })
            .catch((error) => {
            });
        }
      });
    },
    createCreateDiag() {
      this.errorBag = {};
      this.creatediag.gestion = document.querySelector(
        'input[name="gestion"]'
      ).value;
      this.creatediag.motivo = document.querySelector(
        'input[name="motivo"]'
      ).value;
      this.creatediag.nota_d = document.querySelector(
        'input[name="nota_d"]'
      ).value;

      this.ss
        .createcertCreateDiag(this.creatediag)
        .then((response) => {
          window.open(response.data.pdf_url);
          this.$refs["frm-creatediag"].show();
          this.$refs["view-creatediag"].hide();
        })
        .catch((error) => {
          this.errorBag = error.response.data.errors;
          this.$bvToast.toast(
            "Problema al Crear el Certificado, favor verificar los Datos",
            {
              title: "Error",
              variant: "danger",
              autoHideDelay: 5000,
            }
          );
        });
    },
    draw() {
      window.$(".btn-datatable-CreateDiag").on("click", (evt) => {
        const data = window.$(evt.target)[0].id;
        this.showCreateDiag(data);
      });
    },
  },
  components: {
    dataTable,
    // Loader
  },
  mounted() {
    var persona = JSON.parse(localStorage.getItem("persona"));
    if (!persona) {
      this.$router.push("/Login");
    }
  },
};
